import { getLuxuryPlusSubscriptionItems } from 'checkout/selectors/view/luxuryPlusSubscription'
import { INTL_DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import { addDays, intlFormatter } from 'lib/datetime/dateUtils'
import createSelector from 'lib/web/createSelector'

export const hasActiveLuxPlusSubscriptionRenewal = createSelector(
  (state: App.State) => state.loyalty.member.subscription.item?.renewalStatus,
  (renewalStatus): boolean => {
    return renewalStatus === 'ALLOW_RENEWAL'
  },
)

export const getLuxPlusSubscriptionRenewalOrExpiryDate = createSelector(
  (state: App.State) => state.loyalty.member.subscription.item?.expiryDate,
  (state: App.State) => hasActiveLuxPlusSubscriptionRenewal(state),
  (expiryDate, hasActiveLuxPlusSubscriptionRenewal): string | undefined => {
    if (!expiryDate) return undefined
    const renewalOrExpiryDate = hasActiveLuxPlusSubscriptionRenewal ? addDays(expiryDate, 1) : expiryDate
    return intlFormatter(renewalOrExpiryDate, INTL_DMY_CASUAL_FORMAT)
  },
)

export const prioritisedSubscriptionItem = createSelector(
  (state: App.State) => state.loyalty.member.subscription,
  getLuxuryPlusSubscriptionItems,
  (memberSubscription, checkoutSubscriptionItems): App.MemberSubscriptionItem | App.Checkout.LuxuryPlusSubscriptionItem => {
    // We always want to prioritise the member subscription item if it exists
    // otherwise we use the first item in the cart isLuxuryPlusSubscriptionItem that comes from the subscription offer
    return memberSubscription.item ?? checkoutSubscriptionItems[0]
  },
)

export const getCurrentLoyaltyMemberTier = createSelector(
  (state: App.State) => state.loyalty.member.subscription.item?.tier,
  (currentLoyaltyMemberTier): App.MembershipSubscriptionTier | undefined => currentLoyaltyMemberTier,
)
